export const MAPS_KEY = "AIzaSyCtietD00el1oam_Iq7gkAM-xijH6ojCWM";

export const BASE_URL_DOCKER = "https://api.petlanddxb.com/api";

export const WITHOUT_API = "https://api.petlanddxb.com";
export const REFERRAL_BASE_URL = "https://petlanddxb.com"


// export const BASE_URL_DOCKER = "https://dev-api.petlanddxb.com/api";

// export const WITHOUT_API = "https://dev-api.petlanddxb.com";

// export const REFERRAL_BASE_URL = "https://petlanddev.petlanddxb.com"

export const getApiUrl = (endpoint: string) => BASE_URL_DOCKER + endpoint;
export const getApiUrlWithoutApi = (endpoint: string) => WITHOUT_API + endpoint;

export const GUEST_LOGIN = getApiUrl("/auth/guest-login");

export const CUSTOMER_LOGIN = getApiUrl("/auth/send-otp");

export const CUSTOMER_OTP = getApiUrl("/auth/verify-otp");

export const CUSTOMER_EMAIL_LOGIN = getApiUrl("/auth/send-email-otp");

export const CUSTOMER_EMAIL_OTP = getApiUrl("/auth/verify-email-otp");

export const CUSTOMER_PROFILE = getApiUrl("/user-profile");

export const ADD_GET_ALL_PETS = getApiUrl("/pets");

export const ADDRESS = getApiUrl("/addresses");

export const GET_FILTERED_PACKAGES = getApiUrl(
  "/service/Get-filtered-packages",
);
export const GET_WORKING_DAYS_BY_SERVICEID = getApiUrl(
  "/service/getworkingdaysbyid",
);
export const GET_OFFERS_CALENDAR = getApiUrl("/service/get-offers-calendar");
export const GET_AVAIALBALE_SLOTS = getApiUrl("/service/available-slots");

///////  FOOTER API ////

export const APPLY_JOB = getApiUrl("/user-profile/career/apply");
export const GET_ACTIVE_JOB = getApiUrl("/user-profile/career/get-active-jobs");
export const GET_JOB_DETAILS = getApiUrl(
  "/user-profile/career/get-job-details",
);
export const GET_MY_APPLICATIONS = getApiUrl(
  "/user-profile/career/get-my-applications",
);

export const CREATE_QUERY = getApiUrl("/user-profile/createQuery");
export const GET_FAQ_ACTIVE = getApiUrl("/user-profile/faq/get-active");
export const GET_PAGE = getApiUrl("/user-profile/page/get-page");

// blog//

export const GET_ACTIVE_BLOGS = getApiUrl("/user-profile/blog/get-Active");
export const GET_FEATURED_BLOGS = getApiUrl("/user-profile/blog/get-featured");
export const GET_BLOG_DETAILS = getApiUrl("/user-profile/blog/get-details");

export const UPLOAD_CUSTOMER_FILE = getApiUrl("/user-profile/uploadFile");

///// Screen Dashboard ////

export const GET_SCREEN = getApiUrl("/Screens");

export const CUSTOMER_REFRESH_TOKEN = getApiUrl("/auth/refresh-token");
export const ADMIN_REFRESH_TOKEN = getApiUrl("/auth/admin-refresh-token");

////////   PRODUCT //////////

export const GET_PRODUCT_DETAILS = getApiUrl("/products");
////////   PET //////////
export const GET_PET_DETAILS = getApiUrl("/user-profile/get-pet-by-id");

////////   PRODUCT //////////

export const GET_CHECKOUT_SUMMARY = getApiUrl("/checkout/summary");
export const APPLY_COUPON_CODE = getApiUrl("/Checkout/apply-coupon");
export const REMOVE_COUPON_CODE = getApiUrl("/Checkout/remove-coupon");
export const APPLY_REWARD_POINTS = getApiUrl("/Checkout/apply-reward-points");
export const REMOVE_REWARD_POINTS = getApiUrl("/Checkout/remove-reward-points");
export const APPLY_WALLET = getApiUrl("/Checkout/wallet/apply");
export const REMOVE_WALLET = getApiUrl("/Checkout/wallet");
export const SELECT_FREE_GIFT = getApiUrl("/Checkout/select-free-gift");
export const REMOVE_FREE_GIFT = getApiUrl("/Checkout/remove-free-gift");
export const UPDATE_DONATION = getApiUrl("/Checkout/update-donation");
export const SELECT_ADDRESS = getApiUrl("/Checkout/select-address");
export const PROCESS_TO_CHECKOUT = getApiUrl("/Checkout");

export const UPDATE_CART_SUBSCRIPTION =
    getApiUrl("/Checkout/product");

export const UPDATE_PET_PURCHASE_TYPE =
    getApiUrl("/Checkout/pet");

export const PRODUCT_CART_MODIFICATION = getApiUrl("/Checkout/product");
export const PET_CART_MODIFICATION = getApiUrl("/Checkout/pet");
export const SERVICE_CART_MODIFICATION = getApiUrl("/Checkout/service");

export const SEARCH_SUGGESTIONS = getApiUrl("/search/suggestions");
export const SEARCH_PRODUCTS = getApiUrl("/search/products");
export const SEARCH_FILTERS = getApiUrl("/search/filters");
export const SEARCH_PETS = getApiUrl("/search/pets");
export const SEARCH_PETS_FILTERS = getApiUrl("/search/pet-filters");
/// PAYMENT //

export const PAYMENT_INITIATE = getApiUrl("/payments/initiate");

export const PAYMENT_STATUS = getApiUrl("/payments/status");

// Cart Items //

export const CREATE_CART = getApiUrl("/cart");
export const GET_CART = getApiUrl("/cart");
export const UPDATE_CART_ITEM = getApiUrl("/cart");
export const DELETE_CART = getApiUrl("/cart");
export const GET_USER_CART = getApiUrl("/cart/getUserCart");
export const ADD_BUNDLE_TO_CART = getApiUrl("/cart/bundle");

export const ADD_PET_TO_CART = getApiUrl("/cart/addToPetCart");
export const REMOVE_PET_TO_CART = getApiUrl("/cart/removePetCart");
export const REMOVE_SERVICE_TO_CART = getApiUrl("/cart/removeServiceCart");

// GET PRODUCTS BY ID|

export const GetProductsBycategory = getApiUrl("/products");

/// WALLETS PAYEMNT ///

export const GET_WALLETS_TOP_UP = getApiUrl("/Wallet/topup-offers");
export const WALLETS_TOP_UP = getApiUrl("/Wallet/topup");

export const WALLET_TRANSACTIONS_HISTROY = getApiUrl("/Wallet/history");
export const GET_WALLET = getApiUrl("/Wallet");

///// SUBSCRIPTION ///

export const CUSTOMER_SUBSCRIPTION = getApiUrl("/subscriptions");

///// Customer Orders ///
export const GET_CUSTOMER_ORDERS = getApiUrl("/customer/orders");
//// UPLOAD CUSTOMER //

// Customer Orders Details //

export const GET_CUSTOMER_ORDER_DETAILS = getApiUrl("/customer/orders");

export const RETRY_PAYMENT = getApiUrl("/payments/retry-revision");
export const UPDATE_REVISION = getApiUrl("/customer/order-workflow/submit");
export const WALLET_PAYMENT = getApiUrl("/payments/complete-internal");
export const PAYMENT_SUCCESS_DETAILS = getApiUrl(
  "/payments/result/{transactionReference}",
);

///// BOOKINGS ////

export const GET_SERVICES = getApiUrl("/customer-booking/services");
export const GET_PACKAGES = getApiUrl("/customer-booking/packages");
export const GET_OFFER_CALENDAR = getApiUrl("/customer-booking/offer-calendar");
export const GET_AVAILABLE_SLOTS = getApiUrl(
  "/customer-booking/available-slots",
);
export const GET_PACKAGE_ADD_ONS = getApiUrl(
  "/customer-booking/package-addons",
);
export const GET_MY_BOOKINGS = getApiUrl("/customer-booking/my-bookings");

export const GET_BOOKING_BY_ID = getApiUrl("/customer-booking/booking");
export const CANCEL_BOOKING = getApiUrl("/customer-booking/cancel-booking");
export const RESCHEDULE_BOOKING = getApiUrl(
  "/customer-booking/reschedule-booking",
);

export const GET_WORKING_DAY = getApiUrl(
  "/customer-booking/getworkingdaysbyid",
);
export const UPCOMING_BOOKING = getApiUrl("/customer-booking/upcoming-booking");
export const RESCHEDULE_SLOTS = getApiUrl("/customer-booking/reschedule-slots");
export const FREE_PACKAGE_RESCHEDULE_SLOTS = getApiUrl("/customer-booking/free-package-slots");
export const MY_PACKAGES = getApiUrl("/customer-booking/my-packages");
export const FREE_PACKAGE_BOOKINGS = getApiUrl(
  "/customer-booking/free-package-booking",
);
export const CALCULATE_PETTAXI_PRICE = getApiUrl(
  "/customer-booking/pet-taxi/calculate-price",
);
export const ADD_SERVICE_TO_CART = getApiUrl("/cart/addServiceCart");

// REWARDS //

export const CUSTOMER_REWARD = getApiUrlWithoutApi("/rewards");

export const TRACK_ANALYTICS_EVENT = getApiUrl("/analytics/events");
